import { DocumentaryEvidenceInterface } from '@app/core/interfaces/documentary-evidence.interface';

export class DocumentaryEvidenceHelper {
    public static CreateDocumentaryEvidence(data): DocumentaryEvidenceInterface {
        return {
            aanvullend_bewijsstuk_code: (data.aanvullend_bewijsstuk_code) ? data.aanvullend_bewijsstuk_code : null,
            aanvullend_bewijsstuk_code_omschrijving: (data.aanvullend_bewijsstuk_code_omschrijving)
                ? data.aanvullend_bewijsstuk_code_omschrijving : null,
            aanvullend_bewijsstuk_omschrijving: (data.aanvullend_bewijsstuk_omschrijving)
                ? data.aanvullend_bewijsstuk_omschrijving : null,
            bewijsstuk_geleden_schade_volgnummer: (data.bewijsstuk_geleden_schade_volgnummer)
                ? data.bewijsstuk_geleden_schade_volgnummer : null,
            bewijsstuk_schadeobject_id: (data.bewijsstuk_schadeobject_id) ? data.bewijsstuk_schadeobject_id : null,
            bewijsstuk_schadeobject_omschrijving: (data.bewijsstuk_schadeobject_omschrijving)
                ? data.bewijsstuk_schadeobject_omschrijving : null,
            bewijsstuk_volgnummer: (data.bewijsstuk_volgnummer) ? data.bewijsstuk_volgnummer : null,
            document: (data.document) ? data.document : [],
            document_id: (data.document_id) ? data.document_id : null,
            document_omschrijving: (data.document_omschrijving) ? data.document_omschrijving : null,
            dossier_volgnummer: (data.dossier_volgnummer) ? data.dossier_volgnummer : null,
            dossier_volgnummer_omschrijving: (data.dossier_volgnummer_omschrijving) ? data.dossier_volgnummer_omschrijving : null,
            knoppen: (data.knoppen) ? data.knoppen : [],
            medewerker_id: (data.medewerker_id) ? data.medewerker_id : null,
            ongedaan_medewerker_id: (data.ongedaan_medewerker_id) ? data.ongedaan_medewerker_id : null,
            ongedaan_medewerker_omschrijving: (data.ongedaan_medewerker_omschrijving) ? data.ongedaan_medewerker_omschrijving : null,
            ongedaan_moment: (data.ongedaan_moment) ? data.ongedaan_moment : null,
            ongedaan_organisatie_id: (data.ongedaan_organisatie_id) ? data.ongedaan_organisatie_id : null,
            ongedaan_reden_code: (data.ongedaan_reden_code) ? data.ongedaan_reden_code : null,
            ongedaan_reden_omschrijving: (data.ongedaan_reden_omschrijving) ? data.ongedaan_reden_omschrijving : null,
            organisatie_id: (data.organisatie_id) ? data.organisatie_id : null,
            organisatie_omschrijving: (data.organisatie_omschrijving) ? data.organisatie_omschrijving : null,
            overlegd_medewerker_id: (data.overlegd_medewerker_id) ? data.overlegd_medewerker_id : null,
            overlegd_moment: (data.overlegd_moment) ? data.overlegd_moment : null,
            overlegd_organisatie_id: (data.overlegd_organisatie_id) ? data.overlegd_organisatie_id : null,
            pg_bewijsstuk: (data.pg_bewijsstuk) ? data.pg_bewijsstuk : null,
            pg_omschrijving: (data.pg_omschrijving) ? data.pg_omschrijving : null,
            pg_status_code: (data.pg_status_code) ? data.pg_status_code : null,
            pg_status_code_omschrijving: (data.pg_status_code_omschrijving) ? data.pg_status_code_omschrijving : null,
            registratiemoment: (data.registratiemoment) ? data.registratiemoment : null,
            relatie_id: (data.relatie_id) ? data.relatie_id : null,
            schadeobject_id: (data.schadeobject_id) ? data.schadeobject_id : null,
            schadeobject_omschrijving: (data.schadeobject_omschrijving) ? data.schadeobject_omschrijving : null,
            soort_bewijsstuk_code: (data.soort_bewijsstuk_code) ? data.soort_bewijsstuk_code : null,
            soort_bewijsstuk_omschrijving: (data.soort_bewijsstuk_omschrijving) ? data.soort_bewijsstuk_omschrijving : null,
            valid: (data.valid) ? (data.valid) : null
        };
    }
}
